module.exports = __webpack_public_path__ + "img/deadline-expired.7755c896.svg";